// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MOJE珠宝定制系统 - 高端奢华主题 */
/* 主色调：银灰色 + 金色点缀 + 钻石质感 */

:root {
  --moje-gold: #C9A962;
  --moje-gold-light: #E8D4A8;
  --moje-gold-dark: #8B7355;
  --moje-silver: #C0C0C0;
  --moje-silver-light: #E8E8E8;
  --moje-silver-dark: #8A8A8A;
  --moje-platinum: #E5E4E2;
  --moje-charcoal: #2C2C2C;
  --moje-dark-gray: #3D3D3D;
  --moje-medium-gray: #6B6B6B;
  --moje-light-gray: #F5F5F5;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, var(--moje-light-gray) 0%, var(--moje-platinum) 100%);
  color: var(--moje-charcoal);
  overflow-x: hidden;
}

/* 填满 #app，主壳用 overflow:hidden + 内层 Content 滚动；登录等全屏路由用 --scroll 变体 */
.app-router-fill {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.app-router-fill--scroll {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

/* 奢华渐变背景 */
.luxury-gradient {
  background: linear-gradient(145deg, #f8f8f8 0%, #e8e8e8 50%, #d4d4d4 100%);
}

.luxury-gradient-dark {
  background: linear-gradient(145deg, var(--moje-charcoal) 0%, var(--moje-dark-gray) 100%);
}

/* 滚动条样式 - 金色主题 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: linear-gradient(180deg, var(--moje-light-gray) 0%, var(--moje-platinum) 100%);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, var(--moje-gold) 0%, var(--moje-gold-dark) 100%);
  border-radius: 4px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, var(--moje-gold-light) 0%, var(--moje-gold) 100%);
}

/* 链接样式 */
a {
  color: var(--moje-gold-dark);
  text-decoration: none;
  transition: all 0.3s ease;
}

a:hover {
  color: var(--moje-gold);
  text-decoration: none;
}

a:active {
  color: var(--moje-gold-dark);
}

/* 按钮样式覆盖 - 金色主题 */
.ant-btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.ant-btn:not(.ant-btn-sm):not(.ant-btn-lg) {
  height: 40px;
  padding: 0 20px;
  line-height: 38px;
}

.ant-btn-sm {
  height: 32px;
  padding: 0 14px;
  line-height: 30px;
}

.ant-btn-lg {
  height: 48px;
  padding: 0 24px;
  line-height: 46px;
}

/* 图标按钮保持正方形 */
.ant-btn-icon-only:not(.ant-btn-sm):not(.ant-btn-lg) {
  width: 40px;
  padding: 0;
}
.ant-btn-icon-only.ant-btn-sm {
  width: 32px;
  padding: 0;
}
.ant-btn-icon-only.ant-btn-lg {
  width: 48px;
  padding: 0;
}

/* 主按钮 - 金色渐变 */
.ant-btn-primary {
  background: linear-gradient(145deg, var(--moje-gold) 0%, var(--moje-gold-dark) 100%);
  border-color: var(--moje-gold);
  color: #fff;
  box-shadow: 0 4px 15px rgba(201, 169, 98, 0.3);
}

.ant-btn-primary:hover,
.ant-btn-primary:focus {
  background: linear-gradient(145deg, var(--moje-gold-light) 0%, var(--moje-gold) 100%);
  border-color: var(--moje-gold-light);
  box-shadow: 0 6px 20px rgba(201, 169, 98, 0.4);
  transform: translateY(-1px);
}

.ant-btn-primary:active {
  background: linear-gradient(145deg, var(--moje-gold-dark) 0%, var(--moje-gold) 100%);
  box-shadow: 0 2px 8px rgba(201, 169, 98, 0.3);
  transform: translateY(0);
}

/* 默认按钮 - 银色边框 */
.ant-btn-default {
  background: transparent;
  border-color: var(--moje-silver);
  color: var(--moje-charcoal);
}

.ant-btn-default:hover,
.ant-btn-default:focus {
  background: rgba(201, 169, 98, 0.05);
  border-color: var(--moje-gold);
  color: var(--moje-gold-dark);
}

/* 虚线按钮 */
.ant-btn-dashed {
  border-color: var(--moje-silver);
}

.ant-btn-dashed:hover {
  border-color: var(--moje-gold);
  color: var(--moje-gold-dark);
}

/* 输入框样式 - 银色边框 */
.ant-input,
.ant-input-number,
.ant-select-selector,
.ant-picker {
  border-radius: 8px !important;
  border-color: var(--moje-silver) !important;
  transition: all 0.3s ease;
}

.ant-input:focus,
.ant-input-number:focus,
.ant-select-selector:focus,
.ant-picker:focus {
  border-color: var(--moje-gold) !important;
  box-shadow: 0 0 0 2px rgba(201, 169, 98, 0.15) !important;
}

/* 表格样式 - 精致边框 */
.ant-table {
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.ant-table-thead > tr > th {
  background: linear-gradient(180deg, var(--moje-light-gray) 0%, #fff 100%);
  font-weight: 600;
  color: var(--moje-charcoal);
  border-bottom: 2px solid var(--moje-gold);
}

.ant-table-tbody > tr:hover > td {
  background: rgba(201, 169, 98, 0.05);
}

.ant-table-tbody > tr > td {
  border-bottom: 1px solid var(--moje-silver-light);
}

/* 卡片样式 - 奢华质感 */
.ant-card {
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid var(--moje-silver-light);
}

.ant-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.ant-card-head {
  background: linear-gradient(180deg, var(--moje-light-gray) 0%, #fff 100%);
  border-bottom: 1px solid var(--moje-silver-light);
}

.ant-card-head-title {
  color: var(--moje-charcoal);
  font-weight: 600;
}

/* 布局样式 */
.ant-layout {
  background: transparent;
}

.ant-layout-header {
  padding: 0 24px;
  height: 70px;
  line-height: 70px;
  background: linear-gradient(180deg, #fff 0%, var(--moje-light-gray) 100%);
  border-bottom: 1px solid var(--moje-silver-light);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.ant-layout-sider {
  background: linear-gradient(180deg, #fff 0%, var(--moje-light-gray) 100%);
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.08);
}

.ant-layout-content {
  min-height: calc(100vh - 70px);
}

/* 菜单样式 */
.ant-menu {
  border-right: none;
  background: transparent;
}

.ant-menu-item {
  margin: 4px 8px !important;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.ant-menu-item:hover {
  background: rgba(201, 169, 98, 0.1) !important;
}

.ant-menu-item-selected {
  background: linear-gradient(145deg, rgba(201, 169, 98, 0.15) 0%, rgba(201, 169, 98, 0.05) 100%) !important;
  border-right: 3px solid var(--moje-gold) !important;
}

.ant-menu-item-selected::after {
  border-right-color: var(--moje-gold) !important;
}

.ant-menu-submenu-title {
  margin: 4px 8px !important;
  border-radius: 8px;
}

.ant-menu-submenu-title:hover {
  background: rgba(201, 169, 98, 0.1) !important;
}

/* 标签页样式 */
.ant-tabs {
  background: #fff;
  padding: 0 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.ant-tabs-tab {
  padding: 16px 0;
  margin: 0 24px 0 0;
  border-radius: 8px 8px 0 0;
  transition: all 0.3s ease;
}

.ant-tabs-tab:hover {
  color: var(--moje-gold);
}

.ant-tabs-tab-active {
  font-weight: 600;
  color: var(--moje-gold-dark);
}

.ant-tabs-ink-bar {
  background: linear-gradient(90deg, var(--moje-gold) 0%, var(--moje-gold-dark) 100%);
  height: 3px;
  border-radius: 2px;
}

/* 表单样式 */
.ant-form-item-label > label {
  font-weight: 500;
  color: var(--moje-charcoal);
}

.ant-form-item-explain-error {
  font-size: 12px;
}

/* 模态框样式 */
.ant-modal-content {
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.ant-modal-header {
  border-radius: 16px 16px 0 0;
  background: linear-gradient(180deg, var(--moje-light-gray) 0%, #fff 100%);
  border-bottom: 1px solid var(--moje-silver-light);
}

.ant-modal-title {
  color: var(--moje-charcoal);
  font-weight: 600;
}

.ant-modal-footer {
  border-top: 1px solid var(--moje-silver-light);
  padding: 16px 24px;
  background: linear-gradient(180deg, #fff 0%, var(--moje-light-gray) 100%);
}

/* 通知样式 */
.ant-notification {
  z-index: 9999;
}

.ant-notification-notice {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

/* 徽章样式 */
.ant-badge-count {
  background: linear-gradient(145deg, var(--moje-gold) 0%, var(--moje-gold-dark) 100%);
  border: 2px solid #fff;
}

/* 选择器样式 */
.ant-select-dropdown {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

/* 日期选择器 */
.ant-picker-dropdown {
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

/* 加载动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.shimmer {
  background: linear-gradient(90deg, transparent, rgba(201, 169, 98, 0.1), transparent);
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
}

.fade-in {
  animation: fadeIn 0.3s ease-out;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .ant-layout-sider {
    display: none;
  }
  
  .ant-layout-header {
    padding: 0 16px;
  }
  
  .ant-table {
    font-size: 12px;
  }
}

/* 打印样式 */
@media print {
  .no-print {
    display: none !important;
  }
  
  body {
    background: white;
  }
  
  .ant-layout-content {
    margin: 0 !important;
    padding: 0 !important;
  }
}

/* 自定义工具类 */
.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.gap-8 {
  gap: 8px;
}

.gap-16 {
  gap: 16px;
}

.gap-24 {
  gap: 24px;
}

.mt-8 {
  margin-top: 8px;
}

.mt-16 {
  margin-top: 16px;
}

.mt-24 {
  margin-top: 24px;
}

.mb-8 {
  margin-bottom: 8px;
}

.mb-16 {
  margin-bottom: 16px;
}

.mb-24 {
  margin-bottom: 24px;
}

.p-16 {
  padding: 16px;
}

.p-24 {
  padding: 24px;
}

.border-radius-8 {
  border-radius: 8px;
}

.box-shadow {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.box-shadow-hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

/* 状态颜色 */
.status-success {
  color: #52c41a;
}

.status-warning {
  color: var(--moje-gold);
}

.status-error {
  color: #ff4d4f;
}

.status-processing {
  color: #1890ff;
}

.status-default {
  color: var(--moje-silver-dark);
}

/* 背景颜色 */
.bg-success {
  background-color: #f6ffed;
}

.bg-warning {
  background-color: rgba(201, 169, 98, 0.1);
}

.bg-error {
  background-color: #fff2f0;
}

.bg-processing {
  background-color: #e6f7ff;
}

/* 自定义组件样式 */
.custom-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid var(--moje-silver-light);
}

.custom-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.custom-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--moje-silver-light);
}

.custom-card-title {
  font-weight: 600;
  color: var(--moje-charcoal);
  font-size: 16px;
}

.custom-table {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.custom-table .ant-table-thead > tr > th {
  background: linear-gradient(180deg, var(--moje-light-gray) 0%, #fff 100%);
  font-weight: 600;
  border-bottom: 2px solid var(--moje-gold);
}

.custom-form {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.custom-modal .ant-modal-content {
  border-radius: 16px;
}

.custom-modal .ant-modal-header {
  border-radius: 16px 16px 0 0;
}

/* 动画效果 */
@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideInUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideInDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes sparkle {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

.sparkle {
  animation: sparkle 2s infinite;
}

.slide-in-right {
  animation: slideInRight 0.3s ease-out;
}

.slide-in-left {
  animation: slideInLeft 0.3s ease-out;
}

.slide-in-up {
  animation: slideInUp 0.3s ease-out;
}

.slide-in-down {
  animation: slideInDown 0.3s ease-out;
}

/* 过渡效果 */
.transition-all {
  transition: all 0.3s ease;
}

.transition-transform {
  transition: transform 0.3s ease;
}

.transition-opacity {
  transition: opacity 0.3s ease;
}

/* 自定义滚动区域 */
.scrollable-area {
  overflow-y: auto;
  max-height: 400px;
}

.scrollable-area::-webkit-scrollbar {
  width: 6px;
}

.scrollable-area::-webkit-scrollbar-track {
  background: var(--moje-light-gray);
}

.scrollable-area::-webkit-scrollbar-thumb {
  background: var(--moje-gold);
  border-radius: 3px;
}

.scrollable-area::-webkit-scrollbar-thumb:hover {
  background: var(--moje-gold-dark);
}

/* 金色装饰线 */
.gold-divider {
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, var(--moje-gold) 50%, transparent 100%);
  margin: 24px 0;
}

/* 奢华标题样式 */
.luxury-title {
  background: linear-gradient(135deg, var(--moje-gold-dark) 0%, var(--moje-gold) 50%, var(--moje-gold-light) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 600;
}

/* 钻石质感按钮 */
.diamond-btn {
  background: linear-gradient(145deg, #fff 0%, var(--moje-platinum) 50%, #fff 100%);
  border: 1px solid var(--moje-silver);
  border-radius: 8px;
  padding: 12px 24px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.diamond-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s ease;
}

.diamond-btn:hover::before {
  left: 100%;
}

.diamond-btn:hover {
  border-color: var(--moje-gold);
  box-shadow: 0 4px 16px rgba(201, 169, 98, 0.2);
}

/* 卡片悬浮效果 */
.card-hover {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.card-hover:hover {
  transform: translateY(-4px) scale(1.01);
}

/* 渐变文字 */
.gradient-text {
  background: linear-gradient(135deg, var(--moje-gold-dark) 0%, var(--moje-gold) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.app-route-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  padding: 48px;
}`, "",{"version":3,"sources":["webpack://./src/renderer/App.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB,0BAA0B;;AAE1B;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iHAAiH;EACjH,mCAAmC;EACnC,kCAAkC;EAClC,yFAAyF;EACzF,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iCAAiC;AACnC;;AAEA,WAAW;AACX;EACE,0EAA0E;AAC5E;;AAEA;EACE,wFAAwF;AAC1F;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yFAAyF;EACzF,kBAAkB;AACpB;;AAEA;EACE,oFAAoF;EACpF,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,qFAAqF;AACvF;;AAEA,SAAS;AACT;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,oFAAoF;EACpF,8BAA8B;EAC9B,WAAW;EACX,8CAA8C;AAChD;;AAEA;;EAEE,qFAAqF;EACrF,oCAAoC;EACpC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,oFAAoF;EACpF,6CAA6C;EAC7C,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,SAAS;AACT;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;;;;EAIE,6BAA6B;EAC7B,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;;;;EAIE,yCAAyC;EACzC,yDAAyD;AAC3D;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,yEAAyE;EACzE,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iDAAiD;AACnD;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,yEAAyE;EACzE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,yEAAyE;EACzE,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,yEAAyE;EACzE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,0GAA0G;EAC1G,mDAAmD;AACrD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mFAAmF;EACnF,WAAW;EACX,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,yEAAyE;EACzE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,yEAAyE;AAC3E;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,SAAS;AACT;EACE,oFAAoF;EACpF,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,SAAS;AACT;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,qFAAqF;EACrF,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,SAAS;AACT;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,SAAS;AACT;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,yEAAyE;EACzE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,SAAS;AACT;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,SAAS;AACT;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,UAAU;AACV;EACE,WAAW;EACX,0FAA0F;EAC1F,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,gHAAgH;EAChH,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,iFAAiF;EACjF,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA,WAAW;AACX;EACE,iDAAiD;AACnD;;AAEA;EACE,uCAAuC;AACzC;;AAEA,SAAS;AACT;EACE,oFAAoF;EACpF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf","sourcesContent":["/* MOJE珠宝定制系统 - 高端奢华主题 */\r\n/* 主色调：银灰色 + 金色点缀 + 钻石质感 */\r\n\r\n:root {\r\n  --moje-gold: #C9A962;\r\n  --moje-gold-light: #E8D4A8;\r\n  --moje-gold-dark: #8B7355;\r\n  --moje-silver: #C0C0C0;\r\n  --moje-silver-light: #E8E8E8;\r\n  --moje-silver-dark: #8A8A8A;\r\n  --moje-platinum: #E5E4E2;\r\n  --moje-charcoal: #2C2C2C;\r\n  --moje-dark-gray: #3D3D3D;\r\n  --moje-medium-gray: #6B6B6B;\r\n  --moje-light-gray: #F5F5F5;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background: linear-gradient(135deg, var(--moje-light-gray) 0%, var(--moje-platinum) 100%);\r\n  color: var(--moje-charcoal);\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* 填满 #app，主壳用 overflow:hidden + 内层 Content 滚动；登录等全屏路由用 --scroll 变体 */\r\n.app-router-fill {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.app-router-fill--scroll {\r\n  overflow: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n/* 奢华渐变背景 */\r\n.luxury-gradient {\r\n  background: linear-gradient(145deg, #f8f8f8 0%, #e8e8e8 50%, #d4d4d4 100%);\r\n}\r\n\r\n.luxury-gradient-dark {\r\n  background: linear-gradient(145deg, var(--moje-charcoal) 0%, var(--moje-dark-gray) 100%);\r\n}\r\n\r\n/* 滚动条样式 - 金色主题 */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: linear-gradient(180deg, var(--moje-light-gray) 0%, var(--moje-platinum) 100%);\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: linear-gradient(180deg, var(--moje-gold) 0%, var(--moje-gold-dark) 100%);\r\n  border-radius: 4px;\r\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: linear-gradient(180deg, var(--moje-gold-light) 0%, var(--moje-gold) 100%);\r\n}\r\n\r\n/* 链接样式 */\r\na {\r\n  color: var(--moje-gold-dark);\r\n  text-decoration: none;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\na:hover {\r\n  color: var(--moje-gold);\r\n  text-decoration: none;\r\n}\r\n\r\na:active {\r\n  color: var(--moje-gold-dark);\r\n}\r\n\r\n/* 按钮样式覆盖 - 金色主题 */\r\n.ant-btn {\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  transition: all 0.3s ease;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.ant-btn:not(.ant-btn-sm):not(.ant-btn-lg) {\r\n  height: 40px;\r\n  padding: 0 20px;\r\n  line-height: 38px;\r\n}\r\n\r\n.ant-btn-sm {\r\n  height: 32px;\r\n  padding: 0 14px;\r\n  line-height: 30px;\r\n}\r\n\r\n.ant-btn-lg {\r\n  height: 48px;\r\n  padding: 0 24px;\r\n  line-height: 46px;\r\n}\r\n\r\n/* 图标按钮保持正方形 */\r\n.ant-btn-icon-only:not(.ant-btn-sm):not(.ant-btn-lg) {\r\n  width: 40px;\r\n  padding: 0;\r\n}\r\n.ant-btn-icon-only.ant-btn-sm {\r\n  width: 32px;\r\n  padding: 0;\r\n}\r\n.ant-btn-icon-only.ant-btn-lg {\r\n  width: 48px;\r\n  padding: 0;\r\n}\r\n\r\n/* 主按钮 - 金色渐变 */\r\n.ant-btn-primary {\r\n  background: linear-gradient(145deg, var(--moje-gold) 0%, var(--moje-gold-dark) 100%);\r\n  border-color: var(--moje-gold);\r\n  color: #fff;\r\n  box-shadow: 0 4px 15px rgba(201, 169, 98, 0.3);\r\n}\r\n\r\n.ant-btn-primary:hover,\r\n.ant-btn-primary:focus {\r\n  background: linear-gradient(145deg, var(--moje-gold-light) 0%, var(--moje-gold) 100%);\r\n  border-color: var(--moje-gold-light);\r\n  box-shadow: 0 6px 20px rgba(201, 169, 98, 0.4);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.ant-btn-primary:active {\r\n  background: linear-gradient(145deg, var(--moje-gold-dark) 0%, var(--moje-gold) 100%);\r\n  box-shadow: 0 2px 8px rgba(201, 169, 98, 0.3);\r\n  transform: translateY(0);\r\n}\r\n\r\n/* 默认按钮 - 银色边框 */\r\n.ant-btn-default {\r\n  background: transparent;\r\n  border-color: var(--moje-silver);\r\n  color: var(--moje-charcoal);\r\n}\r\n\r\n.ant-btn-default:hover,\r\n.ant-btn-default:focus {\r\n  background: rgba(201, 169, 98, 0.05);\r\n  border-color: var(--moje-gold);\r\n  color: var(--moje-gold-dark);\r\n}\r\n\r\n/* 虚线按钮 */\r\n.ant-btn-dashed {\r\n  border-color: var(--moje-silver);\r\n}\r\n\r\n.ant-btn-dashed:hover {\r\n  border-color: var(--moje-gold);\r\n  color: var(--moje-gold-dark);\r\n}\r\n\r\n/* 输入框样式 - 银色边框 */\r\n.ant-input,\r\n.ant-input-number,\r\n.ant-select-selector,\r\n.ant-picker {\r\n  border-radius: 8px !important;\r\n  border-color: var(--moje-silver) !important;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.ant-input:focus,\r\n.ant-input-number:focus,\r\n.ant-select-selector:focus,\r\n.ant-picker:focus {\r\n  border-color: var(--moje-gold) !important;\r\n  box-shadow: 0 0 0 2px rgba(201, 169, 98, 0.15) !important;\r\n}\r\n\r\n/* 表格样式 - 精致边框 */\r\n.ant-table {\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.ant-table-thead > tr > th {\r\n  background: linear-gradient(180deg, var(--moje-light-gray) 0%, #fff 100%);\r\n  font-weight: 600;\r\n  color: var(--moje-charcoal);\r\n  border-bottom: 2px solid var(--moje-gold);\r\n}\r\n\r\n.ant-table-tbody > tr:hover > td {\r\n  background: rgba(201, 169, 98, 0.05);\r\n}\r\n\r\n.ant-table-tbody > tr > td {\r\n  border-bottom: 1px solid var(--moje-silver-light);\r\n}\r\n\r\n/* 卡片样式 - 奢华质感 */\r\n.ant-card {\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n  transition: all 0.3s ease;\r\n  border: 1px solid var(--moje-silver-light);\r\n}\r\n\r\n.ant-card:hover {\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.ant-card-head {\r\n  background: linear-gradient(180deg, var(--moje-light-gray) 0%, #fff 100%);\r\n  border-bottom: 1px solid var(--moje-silver-light);\r\n}\r\n\r\n.ant-card-head-title {\r\n  color: var(--moje-charcoal);\r\n  font-weight: 600;\r\n}\r\n\r\n/* 布局样式 */\r\n.ant-layout {\r\n  background: transparent;\r\n}\r\n\r\n.ant-layout-header {\r\n  padding: 0 24px;\r\n  height: 70px;\r\n  line-height: 70px;\r\n  background: linear-gradient(180deg, #fff 0%, var(--moje-light-gray) 100%);\r\n  border-bottom: 1px solid var(--moje-silver-light);\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.ant-layout-sider {\r\n  background: linear-gradient(180deg, #fff 0%, var(--moje-light-gray) 100%);\r\n  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.ant-layout-content {\r\n  min-height: calc(100vh - 70px);\r\n}\r\n\r\n/* 菜单样式 */\r\n.ant-menu {\r\n  border-right: none;\r\n  background: transparent;\r\n}\r\n\r\n.ant-menu-item {\r\n  margin: 4px 8px !important;\r\n  border-radius: 8px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.ant-menu-item:hover {\r\n  background: rgba(201, 169, 98, 0.1) !important;\r\n}\r\n\r\n.ant-menu-item-selected {\r\n  background: linear-gradient(145deg, rgba(201, 169, 98, 0.15) 0%, rgba(201, 169, 98, 0.05) 100%) !important;\r\n  border-right: 3px solid var(--moje-gold) !important;\r\n}\r\n\r\n.ant-menu-item-selected::after {\r\n  border-right-color: var(--moje-gold) !important;\r\n}\r\n\r\n.ant-menu-submenu-title {\r\n  margin: 4px 8px !important;\r\n  border-radius: 8px;\r\n}\r\n\r\n.ant-menu-submenu-title:hover {\r\n  background: rgba(201, 169, 98, 0.1) !important;\r\n}\r\n\r\n/* 标签页样式 */\r\n.ant-tabs {\r\n  background: #fff;\r\n  padding: 0 24px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.ant-tabs-tab {\r\n  padding: 16px 0;\r\n  margin: 0 24px 0 0;\r\n  border-radius: 8px 8px 0 0;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.ant-tabs-tab:hover {\r\n  color: var(--moje-gold);\r\n}\r\n\r\n.ant-tabs-tab-active {\r\n  font-weight: 600;\r\n  color: var(--moje-gold-dark);\r\n}\r\n\r\n.ant-tabs-ink-bar {\r\n  background: linear-gradient(90deg, var(--moje-gold) 0%, var(--moje-gold-dark) 100%);\r\n  height: 3px;\r\n  border-radius: 2px;\r\n}\r\n\r\n/* 表单样式 */\r\n.ant-form-item-label > label {\r\n  font-weight: 500;\r\n  color: var(--moje-charcoal);\r\n}\r\n\r\n.ant-form-item-explain-error {\r\n  font-size: 12px;\r\n}\r\n\r\n/* 模态框样式 */\r\n.ant-modal-content {\r\n  border-radius: 16px;\r\n  background: #fff;\r\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.ant-modal-header {\r\n  border-radius: 16px 16px 0 0;\r\n  background: linear-gradient(180deg, var(--moje-light-gray) 0%, #fff 100%);\r\n  border-bottom: 1px solid var(--moje-silver-light);\r\n}\r\n\r\n.ant-modal-title {\r\n  color: var(--moje-charcoal);\r\n  font-weight: 600;\r\n}\r\n\r\n.ant-modal-footer {\r\n  border-top: 1px solid var(--moje-silver-light);\r\n  padding: 16px 24px;\r\n  background: linear-gradient(180deg, #fff 0%, var(--moje-light-gray) 100%);\r\n}\r\n\r\n/* 通知样式 */\r\n.ant-notification {\r\n  z-index: 9999;\r\n}\r\n\r\n.ant-notification-notice {\r\n  border-radius: 12px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n/* 徽章样式 */\r\n.ant-badge-count {\r\n  background: linear-gradient(145deg, var(--moje-gold) 0%, var(--moje-gold-dark) 100%);\r\n  border: 2px solid #fff;\r\n}\r\n\r\n/* 选择器样式 */\r\n.ant-select-dropdown {\r\n  border-radius: 12px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n/* 日期选择器 */\r\n.ant-picker-dropdown {\r\n  border-radius: 12px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n/* 加载动画 */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes shimmer {\r\n  0% {\r\n    background-position: -200% 0;\r\n  }\r\n  100% {\r\n    background-position: 200% 0;\r\n  }\r\n}\r\n\r\n.shimmer {\r\n  background: linear-gradient(90deg, transparent, rgba(201, 169, 98, 0.1), transparent);\r\n  background-size: 200% 100%;\r\n  animation: shimmer 2s infinite;\r\n}\r\n\r\n.fade-in {\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n/* 响应式设计 */\r\n@media (max-width: 768px) {\r\n  .ant-layout-sider {\r\n    display: none;\r\n  }\r\n  \r\n  .ant-layout-header {\r\n    padding: 0 16px;\r\n  }\r\n  \r\n  .ant-table {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n/* 打印样式 */\r\n@media print {\r\n  .no-print {\r\n    display: none !important;\r\n  }\r\n  \r\n  body {\r\n    background: white;\r\n  }\r\n  \r\n  .ant-layout-content {\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n  }\r\n}\r\n\r\n/* 自定义工具类 */\r\n.text-ellipsis {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.flex-center {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.flex-between {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.flex-column {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.gap-8 {\r\n  gap: 8px;\r\n}\r\n\r\n.gap-16 {\r\n  gap: 16px;\r\n}\r\n\r\n.gap-24 {\r\n  gap: 24px;\r\n}\r\n\r\n.mt-8 {\r\n  margin-top: 8px;\r\n}\r\n\r\n.mt-16 {\r\n  margin-top: 16px;\r\n}\r\n\r\n.mt-24 {\r\n  margin-top: 24px;\r\n}\r\n\r\n.mb-8 {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.mb-16 {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.mb-24 {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.p-16 {\r\n  padding: 16px;\r\n}\r\n\r\n.p-24 {\r\n  padding: 24px;\r\n}\r\n\r\n.border-radius-8 {\r\n  border-radius: 8px;\r\n}\r\n\r\n.box-shadow {\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.box-shadow-hover {\r\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n/* 状态颜色 */\r\n.status-success {\r\n  color: #52c41a;\r\n}\r\n\r\n.status-warning {\r\n  color: var(--moje-gold);\r\n}\r\n\r\n.status-error {\r\n  color: #ff4d4f;\r\n}\r\n\r\n.status-processing {\r\n  color: #1890ff;\r\n}\r\n\r\n.status-default {\r\n  color: var(--moje-silver-dark);\r\n}\r\n\r\n/* 背景颜色 */\r\n.bg-success {\r\n  background-color: #f6ffed;\r\n}\r\n\r\n.bg-warning {\r\n  background-color: rgba(201, 169, 98, 0.1);\r\n}\r\n\r\n.bg-error {\r\n  background-color: #fff2f0;\r\n}\r\n\r\n.bg-processing {\r\n  background-color: #e6f7ff;\r\n}\r\n\r\n/* 自定义组件样式 */\r\n.custom-card {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n  transition: all 0.3s ease;\r\n  border: 1px solid var(--moje-silver-light);\r\n}\r\n\r\n.custom-card:hover {\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.custom-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 16px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid var(--moje-silver-light);\r\n}\r\n\r\n.custom-card-title {\r\n  font-weight: 600;\r\n  color: var(--moje-charcoal);\r\n  font-size: 16px;\r\n}\r\n\r\n.custom-table {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.custom-table .ant-table-thead > tr > th {\r\n  background: linear-gradient(180deg, var(--moje-light-gray) 0%, #fff 100%);\r\n  font-weight: 600;\r\n  border-bottom: 2px solid var(--moje-gold);\r\n}\r\n\r\n.custom-form {\r\n  background: #fff;\r\n  padding: 24px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.custom-modal .ant-modal-content {\r\n  border-radius: 16px;\r\n}\r\n\r\n.custom-modal .ant-modal-header {\r\n  border-radius: 16px 16px 0 0;\r\n}\r\n\r\n/* 动画效果 */\r\n@keyframes slideInRight {\r\n  from {\r\n    transform: translateX(100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideInLeft {\r\n  from {\r\n    transform: translateX(-100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideInUp {\r\n  from {\r\n    transform: translateY(100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideInDown {\r\n  from {\r\n    transform: translateY(-100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes sparkle {\r\n  0%, 100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    opacity: 0.7;\r\n    transform: scale(1.1);\r\n  }\r\n}\r\n\r\n.sparkle {\r\n  animation: sparkle 2s infinite;\r\n}\r\n\r\n.slide-in-right {\r\n  animation: slideInRight 0.3s ease-out;\r\n}\r\n\r\n.slide-in-left {\r\n  animation: slideInLeft 0.3s ease-out;\r\n}\r\n\r\n.slide-in-up {\r\n  animation: slideInUp 0.3s ease-out;\r\n}\r\n\r\n.slide-in-down {\r\n  animation: slideInDown 0.3s ease-out;\r\n}\r\n\r\n/* 过渡效果 */\r\n.transition-all {\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.transition-transform {\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.transition-opacity {\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n/* 自定义滚动区域 */\r\n.scrollable-area {\r\n  overflow-y: auto;\r\n  max-height: 400px;\r\n}\r\n\r\n.scrollable-area::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.scrollable-area::-webkit-scrollbar-track {\r\n  background: var(--moje-light-gray);\r\n}\r\n\r\n.scrollable-area::-webkit-scrollbar-thumb {\r\n  background: var(--moje-gold);\r\n  border-radius: 3px;\r\n}\r\n\r\n.scrollable-area::-webkit-scrollbar-thumb:hover {\r\n  background: var(--moje-gold-dark);\r\n}\r\n\r\n/* 金色装饰线 */\r\n.gold-divider {\r\n  height: 2px;\r\n  background: linear-gradient(90deg, transparent 0%, var(--moje-gold) 50%, transparent 100%);\r\n  margin: 24px 0;\r\n}\r\n\r\n/* 奢华标题样式 */\r\n.luxury-title {\r\n  background: linear-gradient(135deg, var(--moje-gold-dark) 0%, var(--moje-gold) 50%, var(--moje-gold-light) 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  font-weight: 600;\r\n}\r\n\r\n/* 钻石质感按钮 */\r\n.diamond-btn {\r\n  background: linear-gradient(145deg, #fff 0%, var(--moje-platinum) 50%, #fff 100%);\r\n  border: 1px solid var(--moje-silver);\r\n  border-radius: 8px;\r\n  padding: 12px 24px;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.diamond-btn::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\r\n  transition: left 0.5s ease;\r\n}\r\n\r\n.diamond-btn:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.diamond-btn:hover {\r\n  border-color: var(--moje-gold);\r\n  box-shadow: 0 4px 16px rgba(201, 169, 98, 0.2);\r\n}\r\n\r\n/* 卡片悬浮效果 */\r\n.card-hover {\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.card-hover:hover {\r\n  transform: translateY(-4px) scale(1.01);\r\n}\r\n\r\n/* 渐变文字 */\r\n.gradient-text {\r\n  background: linear-gradient(135deg, var(--moje-gold-dark) 0%, var(--moje-gold) 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.app-route-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 40vh;\r\n  padding: 48px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
